import {
  Activity,
  Archive,
  ArrowRight,
  BarChart3,
  Bot,
  Boxes,
  Building2,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  Circle,
  Clock,
  CornerDownLeft,
  Database,
  ExternalLink,
  Eye,
  FileSignature,
  FileText,
  Github,
  Handshake,
  Layers,
  LayoutDashboard,
  Link,
  ListChecks,
  MessageSquare,
  Moon,
  Network,
  Palette,
  Pencil,
  Phone,
  Plus,
  Rocket,
  Search,
  Settings,
  Table2,
  Tag,
  Sun,
  Trash2,
  Undo2,
  User,
  Users,
  X,
  type LucideProps,
} from 'lucide-react'

const REGISTRY = {
  Activity,
  Archive,
  ArrowRight,
  BarChart3,
  Bot,
  Boxes,
  Building2,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  Circle,
  Clock,
  CornerDownLeft,
  Database,
  ExternalLink,
  Eye,
  FileSignature,
  FileText,
  Github,
  Handshake,
  Layers,
  LayoutDashboard,
  Link,
  ListChecks,
  MessageSquare,
  Moon,
  Network,
  Palette,
  Pencil,
  Phone,
  Plus,
  Rocket,
  Search,
  Settings,
  Table2,
  Tag,
  Sun,
  Trash2,
  Undo2,
  User,
  Users,
  X,
}

/**
 * Lucide, one library, and four sizes.
 *
 * There were eight — 9, 11, 12, 13, 14, 15, 16, 20 — which is what happens when an
 * icon is sized against whatever text happened to be beside it that day. These are
 * sized against the type scale instead, so an icon and its label share a baseline
 * without anybody measuring:
 *
 *   12  in a row, beside `--text-meta` or `--text-label`
 *   14  beside `--text-body`: the default, and most of the app
 *   16  chrome: the header's own controls
 *   20  an empty state, where the icon is the only thing on screen
 */
export type IconName = keyof typeof REGISTRY

export function Icon({ name, ...props }: { name: IconName } & LucideProps) {
  const Cmp = REGISTRY[name] ?? Circle
  return <Cmp {...props} />
}

/** Icon names arrive from the model as plain strings; narrow safely. */
export function iconName(name: string | undefined): IconName {
  return name && name in REGISTRY ? (name as IconName) : 'Circle'
}
